import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import {
    Header,
    Table,
    Button,
    Segment,
    Loader
} from 'semantic-ui-react';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import request from './request';
import axios from 'axios';

const getGradedActivityTypeName = (type) => ((window.$locale !== 'bs' && type.translations && type.translations.length)
    ? (type.translations.find(e => e.language === window.$locale) ? type.translations.find(e => e.language === window.$locale).name : type.name)
    : type.name);

export default class StudentRegisterExams extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            studentId: '',
            studyProgramId: '',
            data: [],
            error: false,
            loading: true,
            registeringExamId: null,

            gradedActivityTypes: []

        };
        this.onStudentIdChange = this.onStudentIdChange.bind(this);
        this.registerExam = this.registerExam.bind(this);
        this.fetchStudentStatus = this.fetchStudentStatus.bind(this);
    }

    componentDidMount() {
        this.fetchStudentStatus();
        request.fetchGradedActivityTypes().then(res => {
            this.setState({ gradedActivityTypes: res.data });
        });
        this.fetchRegisterExams();
    }

    onStudentIdChange(studentId, studyProgramId) {
        this.setState({ studentId, studyProgramId }, () => this.fetchRegisterExams());
    }
    registerExam(gradedActivityId, studentCourseImplementationId) {
        this.setState({ registeringExamId: gradedActivityId });
        let obj = {
            gradedActivityId,
            studentCourseImplementationId
        };
        axios.post('/student-exams/registration/', { ...obj })
            .then(res => {
                toast(<FormattedMessage id="student.registered" />);
                // this.setState({ registeringExamId: null });
                this.fetchRegisterExams();
            }).catch(err => {
                if (err.response.data === 'For this graded activity registration date only one exam can be registered!') {
                    toast(<FormattedMessage id="common.oneExamRestrictionError" />);
                    this.setState({ registeringExamId: null });
                } else {
                    toast(<FormattedMessage id="common.error" />);
                    this.setState({ registeringExamId: null });
                }
            });
    }
    fetchRegisterExams() {
        // this.setState({ loading: true });
        request.fetchExamsToRegister()
            .then(res => {
                this.setState({ data: res.data, loading: false, registeringExamId: null });
            }).catch(err => {
                toast(<FormattedMessage id="common.error" />);
                this.setState({ error: true, registeringExamId: null });
            });
    }

    fetchStudentStatus() {
        axios.get('students/statuses/')
            .then(res => {
                this.setState({
                    studentStatuses: res.data,
                    locked: res.data.locked,
                    graduationDate: res.data.graduationDate,
                    dateOfAbandonment: res.data.dateOfAbandonment,
                    pauseSemester: res.data.pauseSemester,
                    disciplinaryMeasure: res.data.disciplinaryMeasure,

                });
                localStorage.setItem('studentStatuses', JSON.stringify(res.data));
            })
            .catch(err => {
                console.log('Failed to fetch student statuses.');
            });
    }

    render() {
        const { gradedActivityTypes } = this.state;
        return (
            <div>
                <Header as="h1"><FormattedMessage id="student.exams" /></Header>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3"><FormattedMessage id="student.registerExam" /></Header>
                    </Segment>
                    {this.state.loading ? <Segment><div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div></Segment> :
                    <Segment >
                            {
                                this.state.data.length ?

                                    <Table tablet stackable celled selectable>
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell><FormattedMessage id="common.courseName" /></Table.HeaderCell>
                                                <Table.HeaderCell><FormattedMessage id="professorInputGrades.examType" />
                                                    <div style={{
                                                        fontSize: '0.85em',
                                                        color: '#999'
                                                    }}>
                                                        <FormattedMessage id="professorInputGrades.methodName" />
                                                    </div>
                                                </Table.HeaderCell>
                                                <Table.HeaderCell><FormattedMessage id="professorInputGrades.examDateDate" /></Table.HeaderCell>
                                                <Table.HeaderCell><FormattedMessage id="common.teacher" /></Table.HeaderCell>
                                                <Table.HeaderCell><FormattedMessage id="common.classroom" /></Table.HeaderCell>
                                                <Table.HeaderCell><FormattedMessage id="common.comment" /></Table.HeaderCell>
                                                <Table.HeaderCell />
                                            </Table.Row>
                                        </Table.Header>
                                        <Table.Body>
                                            {this.state.data.map(row => (
                                                <Table.Row key={row.gradedActivityId}>
                                                    <Table.Cell verticalAlign="middle">{row.courseName}</Table.Cell>
                                                    <Table.Cell verticalAlign="middle">{row.gradedActivityType ? getGradedActivityTypeName(gradedActivityTypes.find(el => el.id === row.gradedActivityType)) : null}
                                                        <div style={{
                                                            fontSize: '0.85em',
                                                            color: '#999'
                                                        }}>
                                                            {row.gradingMethodName ? row.gradingMethodName : ''}
                                                        </div>
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle">{row.examDate ? moment(row.examDate).format('D. M. YYYY. - HH:mm') : ''}</Table.Cell>
                                                    <Table.Cell verticalAlign="middle">{row.teacherName}</Table.Cell>
                                                    <Table.Cell verticalAlign="middle">{row.classroom}</Table.Cell>
                                                    <Table.Cell verticalAlign="middle">{row.comment}</Table.Cell>
                                                    <Table.Cell textAlign="center" verticalAlign="middle">
                                                        <Button
                                                            disabled={this.state.pauseSemester || this.state.disciplinaryMeasure || this.state.registeringExamId}
                                                            loading={this.state.registeringExamId === row.gradedActivityId}
                                                            color="blue"
                                                            basic
                                                            onClick={() => this.registerExam(row.gradedActivityId, row.studentCourseImplementationId)}
                                                        >
                                                            <FormattedMessage id="student.register" />
                                                        </Button>
                                                    </Table.Cell>
                                                </Table.Row>))}
                                        </Table.Body>
                                    </Table>
                                    : <span><FormattedMessage id="student.noExamsForRegisterMessage" /> </span>
                            }
                        </Segment>}
                </Segment.Group>

                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentRegisterExams/StudentRegisterExams.js